import { Avatar, Stack, Typography } from '@mui/material';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIERS_STEPS } from 'Enum/suppliers';
import { useIsDesktop } from 'Hooks';
import { PurpleEditPen } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { useContext } from 'react';

export const Edit = () => {
  const { setStepIndex } = useContext(SuppliersContext);
  const isDesktop = useIsDesktop();
  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='8px'
      sx={{
        position: isDesktop ? undefined : 'absolute',
        top: '7px',
        right: '7px',
        width: 'fit-content',
        ': hover': {
          cursor: 'pointer',
          textDecoration: 'underline',
        },
      }}
      tabIndex={0}
      onClick={() => setStepIndex(SUPPLIERS_STEPS.FORM)}
      onKeyDown={onEnterOrEscapeKeyDown}
      role='button'
    >
      <Avatar
        alt=''
        src={PurpleEditPen}
        sx={{ width: '20px', height: '20px' }}
      />
      <Typography variant='body5'>
        {Dictionary[DICTIONARY.Suppliers].resultPage.edit}
      </Typography>
    </Stack>
  );
};
